import { render } from "./selectSeat.vue?vue&type=template&id=51154f40&scoped=true"
import script from "./selectSeat.vue?vue&type=script&lang=js"
export * from "./selectSeat.vue?vue&type=script&lang=js"

import "./selectSeat.vue?vue&type=style&index=0&id=51154f40&scoped=true&lang=css"

import exportComponent from "/root/workspace/cinema-admin_TXA8/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51154f40"]])

export default __exports__